import { Box, Image } from "@chakra-ui/react"
import balgodLogo from '../../../assets/images/balgod_logo.jpeg';

export default function Logo(props) {
  return (
    <Box {...props}>
      <Image src={balgodLogo} size="100%" />
    </Box>
  )
}
